import { render, staticRenderFns } from "./RecipeDetailModal.vue?vue&type=template&id=0832291b&lang=pug"
import script from "./RecipeDetailModal.vue?vue&type=script&lang=js"
export * from "./RecipeDetailModal.vue?vue&type=script&lang=js"
import style0 from "./RecipeDetailModal.vue?vue&type=style&index=0&id=0832291b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports